import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import LivroIntituicaoTable from './LivroInstituicaoTable';
import { useDispatch } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { Link } from 'react-router-dom';
import { setLivrosAutor } from '../Autor/actions/actions';
import { initState as initStateLivrosAutor } from '../Autor/actions/reducers';
import LivroInstituicaoFindDialog from './LivroIntituicaoFindDialog';
import { page } from './api-livro-instituicao';
import { errorMessage } from '../../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    paper: {
        padding: '20px',
    },
    table: {
        paddingTop: '20px;',
        margin: '20px'
    },
    title: {
        marginBottom: '20px'
    },
    cursorLink: {
        cursor: 'pointer'
    }
});

const LivroInstituicaoContainer = () => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const [livrosInstituicao, setLivrosInstituicao] = useState({
        content: [],
        size: 0,
        totalElements: 0,
        number: 0
    });
    const [openLivroInstituicaoSearch, setOpenlivroInstituicaoSearch] = useState(null);


    useEffect(() => {
        page(0).then((data) => {
            if (data.error) {
                errorMessage(data.message);
            } else {
                setLivrosInstituicao(data);
            }
        })
    }, []);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProcurarLivro = () => {
        setOpenlivroInstituicaoSearch(true);
        handleMenuClose();
    }

    const handleEditBook = () => {
        dispatch(setLivrosAutor(initStateLivrosAutor))
    }



    const handleChangePage = (event, newPage) => {
        page(newPage).then((data) => {
            if (data.error) {
                errorMessage(data);
            } else {
                setLivrosInstituicao(data)
            }
        });
    };

    return (
        <Container className={classes.paper} component={Paper}>
            <LivroInstituicaoFindDialog
                openDialog={openLivroInstituicaoSearch}
                setOpenDialog={setOpenlivroInstituicaoSearch}
                setLivrosInstituicao={setLivrosInstituicao}
            />
            <Grid container justifyContent="space-between">
                <Grid size={3}>
                    <Typography className={classes.title} variant="h6">
                        Livros Instituição
                    </Typography>
                </Grid>
                <Grid style={{ flexBasis: '5%' }} size={3}>
                    <MenuIcon
                        fontSize='small'
                        className={classes.cursorLink}
                        onClick={(event) => handleMenuClick(event)}
                        color="secondary"
                    />
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem onClick={() => handleProcurarLivro()}>
                            <SearchIcon
                                fontSize='small'
                                color="secondary"
                                style={{ marginRight: '10px' }} />
                            Procurar Livro
                        </MenuItem>
                        <MenuItem
                            onClick={handleEditBook}
                            component={Link}
                            to={{
                                pathname: '/livro-autor',
                            }}
                        >
                            <EditIcon
                                fontSize='small'
                                color="secondary"
                                style={{ marginRight: '10px' }} />
                            Editar Livro
                        </MenuItem>
                    </Menu>
                </Grid>

            </Grid>
            <Grid >
                <LivroIntituicaoTable
                    livrosInstituicao={livrosInstituicao}
                    handleChangePage={handleChangePage}
                />
            </Grid>
        </Container>
    );
}

export default LivroInstituicaoContainer;